export default __webpack_public_path__ + "static/media/saving.33016b60.svg";